import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/common/pg_first_ico.png'
import _imports_1 from '@/assets/common/pg_prev_ico.png'
import _imports_2 from '@/assets/common/pg_next_ico.png'
import _imports_3 from '@/assets/common/pg_end_ico.png'


const _hoisted_1 = { class: "paging_wrap" }
const _hoisted_2 = {
  class: "dataTables_paginate paging_full_numbers",
  id: "list_paginate"
}
const _hoisted_3 = { class: "pagination" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", {
          class: "paginate_button page-item first disabled",
          id: "list_first",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fnPaging(1)))
        }, [
          _createVNode(_component_router_link, {
            to: "#",
            "aria-controls": "list",
            "data-dt-idx": "0",
            tabindex: "0",
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: "paginate_button page-item previous disabled",
          id: "list_previous",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.currentPage > 1 ? $setup.fnPaging($props.currentPage - 1) : ''))
        }, [
          _createVNode(_component_router_link, {
            to: "#",
            "aria-controls": "list",
            "data-dt-idx": "1",
            tabindex: "0",
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        ($props.currentPage <= 3)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Math.min($setup.paging, 5), (index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: ($event: any) => ($setup.fnPaging(index)),
                class: _normalizeClass(["paginate_button page-item", [index === $props.currentPage ? 'active' : '']])
              }, _toDisplayString(index), 11, _hoisted_6))
            }), 128))
          : ($props.currentPage >= $setup.paging - 2)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([$setup.paging - 4, $setup.paging - 3, $setup.paging - 2, $setup.paging - 1, $setup.paging], (index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => ($setup.fnPaging(index)),
                  class: _normalizeClass(["paginate_button page-item", [index === $props.currentPage ? 'active' : '']])
                }, _toDisplayString(index), 11, _hoisted_7))
              }), 128))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList([-2, -1, 0, 1, 2], (offset) => {
                return _createElementVNode("li", {
                  key: $props.currentPage + offset,
                  onClick: ($event: any) => ($setup.fnPaging($props.currentPage + offset)),
                  class: _normalizeClass(["paginate_button page-item", [$props.currentPage + offset === $props.currentPage ? 'active' : '']])
                }, _toDisplayString($props.currentPage + offset), 11, _hoisted_8)
              }), 64)),
        _createElementVNode("li", {
          class: "paginate_button page-item next",
          id: "list_next",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($props.currentPage < $setup.paging ? $setup.fnPaging($props.currentPage + 1) : ''))
        }, [
          _createVNode(_component_router_link, {
            to: "#",
            "aria-controls": "list",
            "data-dt-idx": "4",
            tabindex: "0",
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: "paginate_button page-item last",
          id: "list_last",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.fnPaging($setup.paging)))
        }, [
          _createVNode(_component_router_link, {
            to: "#",
            "aria-controls": "list",
            "data-dt-idx": "5",
            tabindex: "0",
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}